import SectionHeading from './SectionHeading';
import { hotDramas } from '@/mocks/hotDramas';

export default function HotDramas() {
  return (
    <section id="hot" className="scroll-mt-16 bg-background-50 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            icon="ri-fire-line"
            eyebrow="正在热播"
            title="热播剧：正在更新与近期完结的高讨论剧集"
            desc="这一区收录当下讨论度较高的剧集条目，标注了类型、集数与更新状态。想追更的可以先看「更新中」，想一次看完的可以直接挑「已完结」。"
          />
          <a
            href="#rank"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-sm whitespace-nowrap rounded-md border border-background-300 text-foreground-800 cursor-pointer transition-colors hover:bg-background-100"
          >
            查看热度榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotDramas.map((item) => (
            <article
              key={item.id}
              className="flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="shrink-0 w-24 h-32 md:w-28 md:h-36 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.poster}
                  alt={`《${item.title}》热播剧封面`}
                  className="w-full h-full object-top"
                />
              </div>
              <div className="min-w-0 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="shrink-0 px-2 py-0.5 text-xs font-bold rounded-md bg-accent-500 text-background-50">
                    {item.rating}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {item.genre} · {item.year}
                </p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  <span className="px-2 py-0.5 text-xs rounded-md bg-secondary-100 text-secondary-900">
                    共 {item.episodes} 集
                  </span>
                  <span
                    className={`px-2 py-0.5 text-xs rounded-md ${
                      item.status.includes('更新')
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
                <p className="mt-2 text-xs leading-5 text-foreground-600 line-clamp-3">{item.note}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}